<template>
  <div class="appraise_block modal_info__default">
    <div class="appraise"
         v-clickOutside="($event) => closeModal($event)"
    >
      <div class="appraise_header">
        <div class="header_title">{{titleBlock}}</div>
        <div class="header_close"
             @click="close()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.2502 5L11.9994 10.25L6.74984 5L5 6.75L10.2495 12L5 17.25L6.74984 19L11.9994 13.75L17.2502 19L19 17.25L13.7505 12L19 6.75L17.2502 5Z" fill="white" fill-opacity="0.5"/>
          </svg>
        </div>
      </div>

      <div class="appraise_main">
        <div class="main_content">
          <div class="description"
               v-html="description"
          ></div>
        </div>

        <div class="appraise_flexEnd">
          <div class="appraise_btn"
               @click="send()"
          >
            {{titleButton}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: () => {
        return ''
      }
    },
    titleBlock: {
      type: String,
      default: () => {
        return ''
      }
    },
    titleButton: {
      type: String,
      default: () => {
        return ''
      }
    },
    store: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  name: "modalInfoBlock",

  data() {
    return {
      timerClose: false, // разрешить закрыть окно
    }
  },

  created() {
    let th = this;

    setTimeout(function () {
      th.timerClose = true;
    }, 200);

    document.body.addEventListener('keypress', this.checkKeyPress);
  },

  unmounted() {
    document.body.removeEventListener('keypress', this.checkKeyPress);
  },

  methods: {
    // отследить нажатие на клавишу
    checkKeyPress(event) {
      if (this.timerClose && (event.key === "Escape")) {
        this.$emit('closeModal', {})
      }
    },

    // клик по кнопке
    send() {
      this.$emit('buttonClick', this.store)
    },
    // закрыть модальное окно
    close() {
      this.$emit('closeModal', {})
    },

    closeModal($event) {
      let path = $event.path || ($event.composedPath && $event.composedPath());
      let checkClickByNotification = false;

      if (path) {
        for (let i = 0; i < path.length; i++) {

          if ((path[i].nodeName === 'DIV') && (path[i].className.indexOf('notification_component') !== -1)) {
            checkClickByNotification = true;
            break;
          }
        }

        if ((!checkClickByNotification) && (this.timerClose)) {
          this.$emit('closeModal', {})
        }
      } else if (this.timerClose) {
        this.$emit('closeModal', {})
      }
    }
  },


}
</script>


<style scoped lang="scss">
@import "../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #F2F2F2;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_red: #FF6597;
$color_green: #89CE54;
$color_cyan: #C0CADC;
$color_yellow: #FFCC48;

$color_whiteHover: #fafafa;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

.appraise_block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  z-index: 20;
}

.appraise {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  width: 40%;
  max-width: 768px;
  font-family: $font_Geometria;
}

.appraise_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 72px;
  background-color: $color_purple;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 120%;
  color: white;
}

.header_title {
  margin-right: 20px;
}

.header_close {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: $transition_medium;
  cursor: pointer;

  svg path {
    transition: $transition_medium;
  }
}

.header_close:hover {
  svg path {
    fill-opacity: 1;
  }
}

.appraise_main {
  display: flex;
  flex-direction: column;
  padding: 24px 40px 40px 40px;
}

.appraise_flexEnd {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 24px;
}

.appraise_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: $transition_medium;
  cursor: pointer;
  background-color: $color_purple;
  border-radius: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: white;
  width: auto;
  padding: 0 24px;
  height: 50px;
  min-width: 132px;
}

.appraise_btn:hover {
  background-color: $color_purple_4;
}

.appraise_btn:active {
  background-color: $color_purple_5;
}

.appraise_btn_disable, .appraise_btn_disable:hover {
  cursor: default;
  background-color: $color_cyan;
}

.main_content {
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 21px;
  color: $color_black;
}

.unfulfilled {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10px;
}

.unfulfilled_elem {
  margin: 5px 10px 0 0;
  font-weight: 500;
}

@media all and (max-width: 1600px) {
  .appraise {
    border-radius: 12px;
    width: 42%;
  }

  .appraise_header {
    font-style: normal;
    font-weight: bold;
    padding: 0 36px;
    height: 60px;
    font-size: 20px;
    line-height: 120%;
  }

  .header_close {
    width: 22px;
    height: 22px;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  .appraise_main {
    padding: 24px 36px 36px 36px;
  }

  .appraise_flexEnd {
    margin-top: 18px;
  }

  .appraise_btn {
    border-radius: 8px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    height: 48px;
    padding: 0 20px;
  }

}

@media all and (max-width: 1440px) {
  .appraise {
    border-radius: 10px;
    width: 50%;
  }

  .appraise_btn {
    border-radius: 8px;
  }

}

@media all and (max-width: 1280px) {
  .appraise {
    border-radius: 10px;
    width: 58%;
  }

  .appraise_header {
    padding: 0 32px;
  }

  .appraise_main {
    padding: 24px 32px 32px 32px;
  }
}

@media all and (max-width: 1160px) {
  .appraise {
    width: 70%;
  }

  .appraise_flexEnd {
    margin-top: 16px;
  }
}

@media all and (max-width: 960px) {
  .appraise {
    width: 88%;
  }
}

@media all and (max-width: 600px) {
  .appraise {
    width: 100%;
    border-radius: 8px 8px 0 0;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .appraise_header {
    padding: 0 15px;
    height: 58px;
    font-size: 18px;
    line-height: 23px;
  }

  .appraise_main {
    padding: 24px 15px 15px 15px;
  }

  .appraise_btn {
    border-radius: 6px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    height: 48px;
  }

  .appraise_block {
    align-items: end;
  }

  .main_content {
    font-size: 15px;
    line-height: 19px;
  }
}

@media all and (max-width: 360px) {
  .appraise_header {
    height: 54px;
    font-size: 17px;
    line-height: 21px;
  }

  .appraise_btn {
    font-size: 15px;
    line-height: 19px;
    height: 46px;
  }
}
</style>
